import React, {Component} from 'react';
const { connect } = require('react-redux');

import '../../sass/member/MemberIndex.scss';

import HeaderMemberIndex from '../../components/member/HeaderMemberIndex';
import MemberPhotosBlock from '../../components/member/MemberPhotosBlock';
import MemberAmateurFilmsBlock from '../../components/member/MemberAmateurFilmsBlock';
import MemberWallPostsBlock from '../../components/member/MemberWallPostsBlock';
import MemberVirtualGiftsBlock from '../../components/member/MemberVirtualGiftsBlock';
import MemberWishlistBlock from '../../components/member/MemberWishlistBlock';
import MemberGuestbookBlock from '../../components/member/MemberGuestbookBlock';
//modals
import ModalChangeNickName from '../../components/modals/ModalChangeNickName';
import ModalChangePassword from '../../components/modals/ModalChangePassword';
import ModalChangeEmail from '../../components/modals/ModalChangeEmail';
import ModalChangePhone from '../../components/modals/ModalChangePhone';
import ModalChangeAvatar from '../../components/modals/ModalChangeAvatar';
import ModalAddPhoto from '../../components/modals/ModalAddPhoto';
import ModalUploadFilm from '../../components/modals/ModalUploadFilm';
import ModalAddWallPost from '../../components/modals/ModalAddWallPost';
import ModalEmailChangeResult, {EMAIL_CHANGE_STATUSES} from '../../components/modals/ModalEmailChangeResult';

import {t} from 'l10n';

import {getMember} from 'reducers/member';

class MemberIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            edit: false,
            modalChangeNick: false,
            modalChangePassword: false,
            modalChangeEmail: false,
            modalChangePhone: false,
            modalChangeAvatar: false,
            modalAddPhoto: false,
            modalUploadFilm: false,
            modalAddWallPost: false,

            openedMemberPhoto: null,
            editFilm: false,
            emailChangeStatus: null
        }
    }

    componentDidMount() {
        this.props.getMember();
        this.showEmailChangeResult();
    }

    // ?email_change=confirmed|invalid is set by the backend after the email change
    // confirmation link (www/member/validate_email.php). Read on the client only.
    showEmailChangeResult() {
        const {location} = this.props;
        const match = /[?&]email_change=([a-z]+)/.exec((location && location.search) || '');

        if (match && EMAIL_CHANGE_STATUSES.indexOf(match[1]) !== -1) {
            this.setState({emailChangeStatus: match[1]});
        }
    }

    closeEmailChangeResult() {
        const {location, history} = this.props;

        this.setState({emailChangeStatus: null});
        // Drop the parameter so a reload does not show the message again
        if (history && location) {
            history.replace(location.pathname);
        }
    }

    render() {
        let {match, member, openMemberPhoto} = this.props,
            {user, nickChangeRequestSent, stats, memberPhotos, amateurFilms, wallMaterials, virtualGifts, wishlist, guestbookMessages} = member;

        const { 
            edit,
            modalChangeNick,
            modalChangePassword,
            modalChangeEmail,
            modalChangePhone,
            modalChangeAvatar,
            modalAddPhoto,
            modalUploadFilm,
            modalAddWallPost,
            openedMemberPhoto,
            editFilm,
            emailChangeStatus
        } = this.state;

        return (
            <div>
                {emailChangeStatus &&
                    <ModalEmailChangeResult
                        status={emailChangeStatus}
                        closeFn={() => this.closeEmailChangeResult()}
                    />
                }
                <ModalChangeNickName
                    show={modalChangeNick}
                    closeFn={() => this.setState({modalChangeNick: false})}
                />
                <ModalChangePassword
                    show={modalChangePassword}
                    closeFn={() => this.setState({modalChangePassword: false})}
                />
                <ModalChangeEmail
                    user={user}
                    show={modalChangeEmail}
                    closeFn={() => this.setState({modalChangeEmail: false})}
                />
                {modalChangePhone && 
                    <ModalChangePhone
                        user={user}
                        onSuccess={() => this.props.getMember()}
                        closeFn={() => this.setState({modalChangePhone: false})}
                    />
                }
                <ModalChangeAvatar
                    show={modalChangeAvatar}
                    closeFn={() => this.setState({modalChangeAvatar: false})}
                />
                <ModalAddPhoto
                    show={modalAddPhoto}
                    memberPhoto={openedMemberPhoto}
                    closeFn={() => this.setState({modalAddPhoto: false})}
                />
                <ModalUploadFilm
                    editFilm={editFilm}
                    show={modalUploadFilm}
                    closeFn={() => this.setState({modalUploadFilm: false})}
                    onSuccess={() => this.props.getMember()}
                />
                <ModalAddWallPost
                    show={modalAddWallPost}
                    closeFn={() => this.setState({modalAddWallPost: false})}
                    onSuccess={() => this.props.getMember()}
                />
                <HeaderMemberIndex
                    user={user}
                    nickChangeRequestSent={nickChangeRequestSent}
                    stats={stats}
                    edit={edit}
                    toggleEdit={() => this.setState({edit: !this.state.edit})}
                    openChangeAvatarModal={() => this.setState({modalChangeAvatar: true})}
                    openChangeNickModal={() => this.setState({modalChangeNick: true})}
                    openChangePasswordModal={() => this.setState({modalChangePassword: true})}
                    openChangeEmailModal={() => this.setState({modalChangeEmail: true})}
                    openChangePhoneModal={() => this.setState({modalChangePhone: true})}
                />
                <div className={(edit) ? "memberprofile onEdit" : "memberprofile"}>
                    <div className="error-block">
                        <div className="content">
                            <p>
                                {t('Any content not in accordance with CGU will be blocked by administrators by disabling your account (photos of children, email address, website address, ....).')}
                            </p>
                        </div>
                    </div>
                    <MemberPhotosBlock
                        memberPhotos={memberPhotos}
                        match={match}
                        openAddPhotoModal={() => this.setState({modalAddPhoto: true, openedMemberPhoto: null})}
                        editMemberPhoto={(memberPhoto) => this.setState({modalAddPhoto: true, openedMemberPhoto: memberPhoto})}
                    />
                    <MemberAmateurFilmsBlock
                        amateurFilms={amateurFilms}
                        match={match}
                        openUploadFilmModal={() => this.setState({modalUploadFilm: true})}
                    />
                    <MemberWallPostsBlock
                        wallMaterials={wallMaterials}
                        match={match}
                        openAddWallPostModal={() => this.setState({modalAddWallPost: true})}
                    />
                    <MemberVirtualGiftsBlock virtualGifts={virtualGifts} match={match}/>
                    <MemberWishlistBlock wishlist={wishlist}/>
                    <MemberGuestbookBlock guestbookMessages={guestbookMessages} match={match}/>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        member: state.member
    }),({
        getMember: getMember,
    })
)(MemberIndex)


// WEBPACK FOOTER //
// ./src/containers/member/MemberIndex.js